import React, { useEffect, forwardRef, useState, useImperativeHandle } from 'react';
import { Form, Radio } from 'antd';

const FormILT = forwardRef( ( { form, modifiedCallback, disabled = false }, ref ) => {      
    const [ isILTValue, setIsILTValue ] = useState( 0 ); 
    
    useEffect( () => {
        setIsILTValue( form.getFieldValue( 'isILT' ) );
    }, [ form ] );

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { isILTIsModified: false } ); 
            form.setFieldsValue( { isILTModified: undefined } ); 
            setIsILTValue( form.getFieldValue( 'isILT' ) );
            modifiedCallback( false ); 
        }
    } ) );
    
    const updateModified = () => { 
        if ( form.getFieldValue( 'isILT' ) !== form.getFieldValue( 'isILTModified' ) ) {
            form.setFieldsValue( { isILTIsModified: true } ); 
            modifiedCallback( true ); 
        } else {
            form.setFieldsValue( { isILTIsModified: false } ); 
            form.setFieldsValue( { isILTModified: undefined } ); 
            modifiedCallback( false ); 
        }
    };
    
    const handleValueChange = ( e ) => { 
        setIsILTValue( e.target.value );
        form.setFieldsValue( { isILTModified: e.target.value } ); 
        updateModified();
    };
 
    return (
        <div className="form-item-isILT">   
            <div 
                style={ { display: 'flex' } }
            >
                <Form.Item 
                    label={ <h4 style={ { marginBottom: '0' } }>Course Type</h4> }
                >
                    <Radio.Group 
                        disabled={ disabled }
                        size="medium"
                        buttonStyle="solid" 
                        value={ isILTValue } 
                        onChange={ handleValueChange }
                    >
                        <Radio.Button value={ false }>
                            E-Learning
                        </Radio.Button>
                        <Radio.Button value={ true }>
                            Instructor Led Training
                        </Radio.Button>
                    </Radio.Group>
                </Form.Item>
            </div>
 
        </div>
    );
} );

export default FormILT;
